// pages/HomePage.js
import React from 'react';
import About from '../components/AboutPage/About';
import Footer from '../components/Footer';


function AboutPage() {
  return (
    <div>
      <About/>
      <Footer/>
    </div>
  );
}

export default AboutPage;
